// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31mVN","title":"styles_title__13ei1"};